import homePage from "./views/homePage.vue";
import overPPWijzer from "./views/overPPWijzer.vue";
import paginaContent from "./views/paginaContent.vue";

import uwSituatieStartscherm from "./views/uwSituatieStartscherm.vue";
import uwSituatieInitiatief from "./views/uwSituatieInitiatief.vue";
import uwSituatieFase from "./views/uwSituatieFase.vue";
import uwSituatieDoel from "./views/uwSituatieDoel.vue";
import uwSituatieEindscherm from "./views/uwSituatieEindscherm.vue";
import vergelijkMethodes from "./views/vergelijkMethodes.vue";
import methodes from "./views/methodes.vue";
import methodeDetail from "./views/methodeDetail.vue";
import uwVergelijkingEindscherm from "./views/uwVergelijkingEindscherm.vue";
import eindResultaat from "./views/eindResultaat.vue";
import eindResultaatPDF from "./views/eindResultaatPDF.vue";
import eindResultaatPDFDownload from "./views/eindResultaatPDFDownload.vue";
import eindResultaatHTML from "./views/eindResultaatHTML.vue";

export let routes = [
    {
        path: "/",
        name: "home",
        component: homePage,
        meta: {
            type: 'page'
        }
    },
    {
        path: "/pagina/:p",
        name: "paginacontent",
        component: paginaContent,
        meta: {
            type: 'page'
        }
    },
    {
        path: "/start",
        name: "startscherm",
        component: uwSituatieStartscherm,
        meta: {
            type: 'page'
        }
    },
    {
        path: "/uw-situatie-initiatief",
        name: "uw-situatie-initiatief",
        component: uwSituatieInitiatief,
        meta: {
            type: 'page'
        }
    },
    {
        path: "/uw-situatie-overheid/:doelSlug",
        name: "uw-situatie-overheid",
        component: uwSituatieFase,
        meta: {
            type: 'page'
        }
    },
    {
        path: "/uw-situatie-doel/:doelSlug",
        name: "uw-situatie-doel",
        component: uwSituatieDoel,
        meta: {
            type: 'page'
        }
    },
    {
        path: "/uw-situatie-eindscherm/:doelSlug",
        name: "uw-situatie-eindscherm",
        component: uwSituatieEindscherm,
        meta: {
            type: 'page'
        }
    },
    {
        path: "/methodes/:doelSlug",
        //path: "/methodes",
        name: "methodes",
        component: methodes,
        meta: {
            type: 'page'
        }
    },
    {
        path: "/methodes-vergelijking/:doelSlug",
        // path: "/methodes-vergelijking",
        name: "vergelijkMethodes",
        component: vergelijkMethodes,
        meta: {
            type: 'page'
        }
    },
    {
        path: "/methode-detail/:methodeId",
        name: "methode-detail",
        component: methodeDetail,
        meta: {
            type: 'page'
        }
    },
    {
        path: "/uw-vergelijking-resultaat",
        name: "tussenschermResultaat",
        component: uwVergelijkingEindscherm,
        meta: {
            type: 'page'
        }
    },
    {
        path: "/eindresultaat",
        name: "eindResultaat",
        component: eindResultaat,
        meta: {
            type: 'page'
        }
    },
    {
        path: "/pdf",
        name: "eindResultaatPDF",
        component: eindResultaatPDF,
        meta: {
            type: 'page'
        }
    },
    {
        path: "/html",
        name: "versieHTML",
        component: eindResultaatHTML,
        meta: {
            type: 'page'
        }
    },
    {
        path: "/pdf-dl",
        name: "eindResultaatPDFDownload",
        component: eindResultaatPDFDownload,
        meta: {
            type: 'page'
        }
    },
];

export const routesHelper = {
    finalizeRoutes: routes => {
        routes.push({
            path: "*",
            redirect: "/",
        });
    },
    addRoutesFor: ( routes, list, type, slug, component, extra_routes ) => {
        list.forEach((item, index) => {
            routes.push({
                path: `/${slug}/${item.slug}`,
                name: item.slug,
                component,
                meta: {
                    index,
                    type,
                    slug: item.slug
                }
            });

            if (extra_routes) {
                for (const node in extra_routes) {
                    routes.push({
                        path: `/${slug}/${item.slug}/${node}`,
                        name: `${item.slug}-${node}`,
                        component: extra_routes[node],
                        meta: {
                            index,
                            type,
                            slug: item.slug
                        }
                    });
                }
            }
        });
    }
}
